import { space, tok, tokPx } from '@sunwebgroup/ui-components'
import { Typography } from '@sunwebgroup/ui-components/uds/index'
import { styled } from 'styled-components'

export const CarSelectedSheetTrigger = styled.div``
export const CarSelectedSheetTriggerContent = styled.div`
  display: flex;
  align-items: center;
  gap: ${space('primitives_space_12')};
  flex-direction: row;
  cursor: pointer;
`
export const CarSelectedSheetContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`
export const CarSelectedSheetCategoryText = styled(Typography)`
  color: ${tok('semantics_content_color')};
`
export const CarSelectedSheetHintText = styled(Typography)`
  color: ${tok('semantics_content_secondary_color')};;
`
export const CarSelectedSheetTrailing = styled.div`
  display: flex;
  align-items: center;
  gap: ${space('primitives_space_8')};
`
export const CarListName = styled(Typography)`
  color: ${tok('semantics_content_color')};
`
export const CarSheetContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${tokPx('components_form_spacing')};
`
